/**
 * Splits a string on the first detected separator into a primary (date/label) and secondary (title).
 * Auto-detects the separator from the set ".,-_—/|" if none is provided.
 * Terms without a separator are returned as primary only, with secondary undefined.
 *
 * Examples:
 *   "1897-1918. Infancia y juventud" → { primary: "1897-1918", secondary: "Infancia y juventud" }
 *   "Recorrido vital"                → { primary: "Recorrido vital",   secondary: undefined }
 */
// const AUTO_SEPARATORS = ['.', ',', '-', '_', '—', '/', '|'];
const AUTO_SEPARATORS = ['.'];

export function splitTerm(term, separator) {
    if (!term) return { primary: undefined, secondary: undefined };

    const sep = separator ?? AUTO_SEPARATORS.find((s) => term.includes(s));
    if (!sep) return { primary: term, secondary: undefined };

    const idx = term.indexOf(sep);
    if (idx === -1) return { primary: term, secondary: undefined };

    return {
        primary: term.slice(0, idx).trim(),
        secondary: term.slice(idx + sep.length).trim(),
    };
}
